// Recompensa diária: um calendário com uma recompensa para cada dia do mês (1 a 31).
// Cada dia em que o personagem entra ele pode pegar a próxima recompensa do calendário (uma por dia, a sequência
// recomeça no mês seguinte). Ajudam no progresso sem dar poder direto. Tudo cai na Noxara Store Box (preso ao personagem).

export type DailyKind = 'stokens' | 'fragments' | 'exercise' | 'xpboost' | 'bless' | 'gold' | 'coins' | 'preycards';
export interface DailyReward { kind: DailyKind; amount: number; big?: boolean }

// as poções saíram das recompensas (pedido do Arthur, 17/10): agora são automáticas e cobradas por uso.
// No lugar delas: Silver Tokens (imbuement) e fragmentos de pedra de proteção (refine).
const S = (amount: number, big = false): DailyReward => ({ kind: 'stokens', amount, big });
const F = (amount: number): DailyReward => ({ kind: 'fragments', amount });
const E = (amount: number, big = false): DailyReward => ({ kind: 'exercise', amount, big });
const X = (amount: number): DailyReward => ({ kind: 'xpboost', amount });
const G = (amount: number): DailyReward => ({ kind: 'gold', amount });

/** O calendário (índice 0 = dia 1). Tokens e fragmentos: quantidade; exercise: usos; xpboost: minutos; gold: x level; coins: quantidade. */
export const DAILY: DailyReward[] = [
  F(2), E(150), X(30), S(1), G(50), E(200), { kind: 'bless', amount: 1, big: true },
  F(3), X(30), E(250), { kind: 'preycards', amount: 2 }, S(2), X(60), E(500, true),
  F(4), G(100), E(300), X(60), S(2), { kind: 'bless', amount: 1 }, E(500, true),
  F(5), { kind: 'preycards', amount: 3 }, X(60), E(400), S(3), G(150), { kind: 'coins', amount: 10, big: true },
  X(120), E(1000, true), S(5, true),
];

/** Bônus de experiência do boost diário. */
export const XP_BOOST_PCT = 50;

export function dailyLabel(r: DailyReward, level = 1): string {
  switch (r.kind) {
    case 'stokens': return `${r.amount} Silver Token${r.amount > 1 ? 's' : ''} (imbuement)`;
    case 'fragments': return `${r.amount} fragmento${r.amount > 1 ? 's' : ''} de pedra de proteção`;
    case 'exercise': return `Item de treino (${r.amount} usos)`;
    case 'xpboost': return `+${XP_BOOST_PCT}% de XP por ${r.amount} min`;
    case 'bless': return 'Uma bênção';
    case 'gold': return `${(r.amount * Math.max(1, level)).toLocaleString('pt-BR')} gp`;
    case 'coins': return `${r.amount} Noxara Coins`;
    case 'preycards': return `${r.amount} Prey Cards`;
  }
}

export interface DailyState { month: string; claimed: number; last: string }

/** Data de hoje e mês no fuso do Brasil (a virada do dia é à meia-noite de Brasília). */
export function brDate(now = Date.now()): { day: string; month: string } {
  const d = new Date(now - 3 * 3600_000).toISOString();
  return { day: d.slice(0, 10), month: d.slice(0, 7) };
}

/** Estado normalizado para hoje: zera no mês novo; diz se pode pegar e qual é a próxima. */
export function dailyNow(s: Partial<DailyState> | null | undefined, now = Date.now()) {
  const { day, month } = brDate(now);
  const st: DailyState = s?.month === month ? { month, claimed: s.claimed ?? 0, last: s.last ?? '' } : { month, claimed: 0, last: '' };
  const canClaim = st.last !== day && st.claimed < DAILY.length;
  return { ...st, today: day, canClaim, next: st.claimed };
}
